import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
  Box,
} from "@mui/material";
import { useState, useEffect } from "react";

const DemoNoticeDialog = () => {
  const [open, setOpen] = useState(false);
  const [language, setLanguage] = useState("en");

  useEffect(() => {
    // First time app open
    if (!window.demoDisclaimerShown) {
      setOpen(true);

      // Set global flag
      window.demoDisclaimerShown = true;
    }
  }, []);

  // useEffect(() => {
  //   const alreadyShown = sessionStorage.getItem("demoNoticeShown");
  //     // setOpen(true);

  //   if (!alreadyShown) {
  //     setOpen(true);
  //     // sessionStorage.setItem("demoNoticeShown", "true");
  //   }
  // }, []);

  const handleClose = () => {
    // sessionStorage.setItem("demoNoticeShown", "true");
    setOpen(false);
  };

  const handleLanguageChange = (event, newLang) => {
    if (newLang !== null) {
      setLanguage(newLang);
    }
  };

  const content = {
    en: {
      title: "Demo Disclaimer",
      text1:
        "This is a demonstration website created solely for presentation and evaluation purposes. The content, data, reports, workflows, and features displayed are for illustrative use only and do not represent a live production environment.",
      text2:
        "Any names, records, financial figures, beneficiary details, or documents shown are sample or dummy data. This demo does not constitute a legally binding offer, contractual commitment, or final system specification.",
      text3:
        "The actual delivered system may vary based on approved scope, requirements, security policies, compliance guidelines, and deployment environment.",
      button: "I Understand",
    },
    mr: {
      title: "डेमो अस्वीकरण",
      text1:
        "ही वेबसाइट केवळ सादरीकरण आणि मूल्यांकनासाठी तयार करण्यात आलेली डेमो प्रणाली आहे. दर्शवलेली सर्व माहिती, डेटा, अहवाल, प्रक्रिया आणि वैशिष्ट्ये केवळ प्रातिनिधिक आहेत आणि प्रत्यक्ष कार्यरत प्रणालीचे प्रतिनिधित्व करत नाहीत.",
      text2:
        "दाखवलेली नावे, नोंदी, आर्थिक आकडेवारी, लाभार्थी तपशील किंवा कागदपत्रे ही नमुना किंवा काल्पनिक माहिती आहे. हा डेमो कोणताही कायदेशीर करार किंवा अंतिम प्रणाली तपशील दर्शवत नाही.",
      text3:
        "अंतिम प्रणाली मंजूर कार्यक्षेत्र, आवश्यकता, सुरक्षा धोरणे, अनुपालन मार्गदर्शक तत्त्वे आणि तैनाती वातावरणानुसार बदलू शकते.",
      button: "मला समजले",
    },
  };

  return (
    <Dialog open={open} maxWidth="md" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>
        {content[language].title}
      </DialogTitle>

      <DialogContent dividers>
        {/* Language Toggle */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
          <ToggleButtonGroup
            value={language}
            exclusive
            onChange={handleLanguageChange}
            size="small"
          >
            <ToggleButton value="en">English</ToggleButton>
            <ToggleButton value="mr">मराठी</ToggleButton>
          </ToggleButtonGroup>
        </Box>

        <Typography paragraph>{content[language].text1}</Typography>
        <Typography paragraph>{content[language].text2}</Typography>
        <Typography>{content[language].text3}</Typography>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" onClick={handleClose}>
          {content[language].button}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DemoNoticeDialog;